export var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ServerError"] = 9100] = "ServerError";
    ErrorCode[ErrorCode["AuthorizationTokenError"] = 9200] = "AuthorizationTokenError";
    ErrorCode[ErrorCode["SessionExpired"] = 9210] = "SessionExpired";
    ErrorCode[ErrorCode["ImageTransmissionError"] = 9300] = "ImageTransmissionError";
    ErrorCode[ErrorCode["VerificationError"] = 9400] = "VerificationError";
    ErrorCode[ErrorCode["NoNetworkConnection"] = 9800] = "NoNetworkConnection";
    ErrorCode[ErrorCode["UnexpectedClientError"] = 9801] = "UnexpectedClientError";
    ErrorCode[ErrorCode["ProblemCommunicating"] = 9810] = "ProblemCommunicating";
    ErrorCode[ErrorCode["CameraUnavailable"] = 9820] = "CameraUnavailable";
    ErrorCode[ErrorCode["NoAcceptableSubmission"] = 9835] = "NoAcceptableSubmission";
})(ErrorCode || (ErrorCode = {}));
function isSuccess(message) {
    const m = message;
    return m.data && m.data.transactionStatus === 'SUCCESS';
}
function isError(message) {
    const m = message;
    return m.data && m.data.transactionStatus === 'ERROR';
}
export default class GmwNetVerify {
    constructor($log, $q, $sce, $window, HoldingApi) {
        this.$log = $log;
        this.$q = $q;
        this.$sce = $sce;
        this.$window = $window;
        this.HoldingApi = HoldingApi;
        this.init = (code, requireCamera = true) => {
            this.tearDown();
            const deferred = this.$q.defer();
            return this.getScanId(code, requireCamera).then(({ redirectUrl, id }) => {
                // Documentation available here:
                // https://github.com/Jumio/implementation-guides/blob/master/netverify/netverify-web.md
                this.callback = (e) => this.onMessage(e, deferred, id);
                angular
                    .element(this.$window)
                    .on('message', this.callback);
                return {
                    url: this.$sce.trustAsResourceUrl(redirectUrl),
                    promise: deferred.promise,
                };
            });
        };
        this.onMessage = (e, deferred, id) => {
            const originalEvent = e.originalEvent;
            if (typeof originalEvent.data !== 'string') {
                return;
            }
            const message = JSON.parse(originalEvent.data);
            this.$log.debug(message);
            if (isSuccess(message)) {
                this.markFlowAsComplete(id).then(() => {
                    deferred.resolve();
                });
            }
            if (isError(message)) {
                deferred.reject(message.data.errorCode);
            }
        };
        // following 'any' is needed because otherwise TS can't infer the correct overload of off
        this.tearDown = () => {
            angular.element(this.$window).off('message', this.callback);
        };
    }
    getScanId(code, camera) {
        return this.HoldingApi.post('verification/netverify', { code, camera });
    }
    markFlowAsComplete(id) {
        return this.HoldingApi.post(`verification/netverify/${id}`);
    }
}
GmwNetVerify.$inject = ['$log', '$q', '$sce', '$window', 'HoldingApi'];



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/services/netverify.ts